import React from 'react';

export interface AvatarProps {
  name: string | null | undefined;
  color?: string;
  size?: number;
  title?: string;
}

function deriveInitials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
}

export const Avatar: React.FC<AvatarProps> = ({ name, color, size = 22, title }) => {
  const trimmed = (name ?? '').trim();
  const isEmpty = trimmed.length === 0;

  if (isEmpty) {
    return (
      <span
        title={title}
        style={{
          width: size,
          height: size,
          borderRadius: size / 2,
          border: '1.5px dashed var(--color-warm-border-strong)',
          display: 'inline-grid',
          placeItems: 'center',
          color: 'var(--color-ink-3)',
          fontSize: Math.round(size * 0.46),
          flexShrink: 0,
        }}
      >
        ?
      </span>
    );
  }

  return (
    <span
      title={title ?? trimmed}
      style={{
        width: size,
        height: size,
        borderRadius: size / 2,
        background: color ?? 'var(--color-coral)',
        color: '#fff',
        display: 'inline-grid',
        placeItems: 'center',
        fontSize: Math.round(size * 0.46),
        fontWeight: 700,
        flexShrink: 0,
      }}
    >
      {deriveInitials(trimmed)}
    </span>
  );
};

export default Avatar;
